import { FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import * as jnb from 'react-bootstrap';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { useSelector } from 'react-redux';
import Header from '../../../Header/Header';
import { useNavigate } from 'react-router-dom';

export default function ApprovalReport() {
    const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails?.loginData);
    const [showList, setList] = useState([]);

    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            entry_by: loginreducer?.username,
            paymentStatus: "",
            paymentDate: ""

        },
        onSubmit: (values) => {
            console.log("values", JSON.stringify(values));
        },
        //validationSchema: InWardChequeValidation
    })
    function GetChequeInReport() {
        let url = config.url.BOC_URL + "inward-report-approver";
        CommonAxiosGet(url).then((response) => {
            if (response.data.status === true) {
                setList(response.data.inward_count);
            }
            else {
                setList([])
            }
        })
    }
    useEffect(() => {
        GetChequeInReport()

    }, [])
    let navigate = useNavigate()
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="Approval Report" />
            <jnb.Container className="outer-page-content-container" >
                <FormikProvider value={Formik}>
                    <jnb.Form onChange={Formik.handleChange} onSubmit={Formik.handleSubmit} className="form_adjust">
                        <div className="table-responsive">
                            <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                                style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}>
                                <thead>
                                    <tr>
                                        <th>S.NO</th>
                                        <th>Cfms Id</th>
                                        <th>Inward Maker ChequeIn Date</th>
                                       <th>Inward Checker Confirmed Date</th>
                                       <th>Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {showList.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.incharge_cfms_id}</td>
                                            <td className="text-center">{item.in_ward_cheque_in_date}</td>
                                            <td className="text-center">{item?.checker_entry_dt}</td>
                                            <td style={{ textAlign: "center", color: "Highlight", textDecoration: "underline" }}
                                                onClick={() => {
                                                    navigate("/ApprovalPrint", { state: { data: item } })

                                                }}>{item.tot_count}</td>
                                        </tr>
                                    ))}
                                </tbody></table>
                        </div>
                    </jnb.Form>
                </FormikProvider>
            </jnb.Container>




        </React.Fragment>
    )
}
